import React, { useEffect, useState } from "react";
import TopStudents from "../components/TopStudents";
import GradesTable from "../components/GradesTable";
import LabsTable from "../components/LabsTable";
import { fetchTopStudents, fetchStudentsWithGrades } from "../api/api";
import { Tab, Tabs } from "react-bootstrap";
import "./MainPage.css"; // подключаем CSS

const MainPage = () => {
  const [topStudents, setTopStudents] = useState([]);
  const [studentsGrades, setStudentsGrades] = useState({ labs: [], students: [] });
  const [key, setKey] = useState("grades");

  useEffect(() => {
    async function loadTopStudents() {
      try {
        const data = await fetchTopStudents();
        setTopStudents(data);
      } catch (err) {
        console.error("Ошибка загрузки лучших студентов", err);
        setTopStudents([]);
      }
    }

    async function loadGrades() {
      try {
        const data = await fetchStudentsWithGrades();
        setStudentsGrades(data);
      } catch (err) {
        console.error("Ошибка загрузки оценок", err);
        setStudentsGrades({ labs: [], students: [] });
      }
    }

    loadTopStudents();
    loadGrades();
  }, []);

  return (
    <div className="main-page">
      <TopStudents students={topStudents} />

      <div className="tabs-container">
        <Tabs
          id="grades-labs-tabs"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3 custom-tabs"
          variant="pills"
        >
          <Tab eventKey="grades" title="Успеваемость">
            <GradesTable data={studentsGrades} />
          </Tab>
          <Tab eventKey="labs" title="Лабораторные">
            <LabsTable labs={studentsGrades.labs} />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default MainPage;
